import { EuiCard } from "@elastic/eui";
import React from "react";
import LoginScreenContainer from "./container";

export const LoginScreen = () =>{

  return (
    <EuiCard className="cardLogin" title='' description=''><LoginScreenContainer/></EuiCard>
  )
}